import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';
import { getCode } from 'app/utils/method';

/**
 * Route User Cell Renderer
 *
 * Renders route, user, and responsible information using UserRouteDisplayComponent
 *
 * @example
 * ```typescript
 * {
 *   field: 'subRoute',
 *   headerName: 'Ruta - Usuario',
 *   cellRenderer: RouteUserCellRendererComponent,
 *   minWidth: 250
 * }
 * ```
 */
@Component({
  selector: 'app-route-user-cell-renderer',
  standalone: true,
  imports: [CommonModule, UserRouteDisplayComponent],
  template: `
    <app-user-route-display
      [routeData]="{
        routeName: params.data?.subRoute?.name ?? '-',
        externalKeys: {
          code: params.data?.subRoute?.externalKeys?.code ??
                params.data?.subRoute?.code ??
                getCode(params.data?.subRoute) ?? '-'
        }
      }"
      [userData]="{
        name: params.data?.user?.user_login?.username ??
              params.data?.user ??
              params.data?.username ?? '-',
        username: params.data?.user?.user_login?.username ??
                params.data?.user ??
                 params.data?.username ?? '-'
      }"
      [responsibleData]="{
        name: params.data?.responsibleName ??
              params.data?.responsibleBusinessPartner?.name ??
              params.data?.responsible?.name ?? '-',
        personNumber: params.data?.responsibleBusinessPartner?.personNumber ??
                     params.data?.responsible?.personNumber ?? '-',
        externalKeys: {
          code: params.data?.responsibleCode ??
                params.data?.responsibleBusinessPartner?.externalKeys?.code ??
                params.data?.responsible?.externalKeys?.code ?? '-'
        }
      }"
      [displayMode]="'detailed'"
      [showRouteCode]="true"
      [showUser]="true"
      [showResponsible]="true">
    </app-user-route-display>
  `,
})
export class RouteUserCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;
  getCode = getCode;
}
